import app from "@firebase/app";
import {executeSearchQuery} from './firestoreUtils';

const getMakeModelsCollection = () => app.firestore().collection("makemodels");

export const getMakeModels = () => {
    let query = getMakeModelsCollection();
    return executeSearchQuery(query);
};